export default {
  breadcrumbs: {
    id: 'track_parcel_breadcrumbs',
    defaultMessage: 'Breadcrumbs',
  },
  breadcrumbOrders: {
    id: 'track_parcel_breadcrumb_orders',
    defaultMessage: 'Orders',
  },
  breadcrumbTrackShipment: {
    id: 'track_parcel_breadcrumb_track_shipment',
    defaultMessage: 'Track shipment',
  },
  deliveryOnTrack: {
    id: 'track_parcel_delivery_on_track',
    defaultMessage: 'Delivery on track',
  },
  updatedDeliveryDate: {
    id: 'track_parcel_updated_delivery_date',
    defaultMessage: 'Updated delivery date',
  },
  deliveryDelayed: {
    id: 'track_parcel_delivery_delayed',
    defaultMessage: 'Delivery delayed',
  },
  deliveryFailed: {
    id: 'track_parcel_delivery_failed',
    defaultMessage: 'Delivery failed',
  },
  delivered: {
    id: 'track_parcel_delivered',
    defaultMessage: 'Delivered',
  },
  estimatedDelivery: {
    id: 'track_parcel_estimated_delivery',
    defaultMessage: 'Estimated delivery',
  },
  deliveryBy: {
    id: 'track_parcel_delivery_by',
    defaultMessage: 'Delivery by',
  },
  trackingId: {
    id: 'track_parcel_tracking_id',
    defaultMessage: 'Tracking ID',
  },
  needHelpLabel: {
    id: 'track_parcel_need_help',
    defaultMessage: 'Need help?',
  },
  needHelpDescription: {
    id: 'track_parcel_need_help_description',
    defaultMessage:
      'To manage or reschedule your delivery, {contactCarrierLink, html}. To report a missing or damaged package, {contactBackMarketLink, html}.',
  },
  contactCarrier: {
    id: 'track_parcel_contact_carrier',
    defaultMessage: 'contact {carrierName}',
  },
  contactBackMarket: {
    id: 'track_parcel_contact_back_market',
    defaultMessage: 'contact Back Market',
  },
  delayedAlertTitle: {
    id: 'track_parcel_delayed_alert_title',
    defaultMessage: 'Check with {carrierName} for delivery updates',
  },
  delayedAlertDescription: {
    id: 'track_parcel_delayed_alert_description',
    defaultMessage:
      "The shipping provider hasn't shared news with us recently. Please check their website or contact their team for the most recent updates.",
  },
  delayedAlertButton: {
    id: 'track_parcel_delayed_alert_button',
    defaultMessage: 'Go to {carrierName} tracking page',
  },
  seeAllUpdates: {
    id: 'track_parcel_see_all_updates',
    defaultMessage: 'See all updates',
  },
  allUpdates: {
    id: 'track_parcel_all_updates',
    defaultMessage: 'All updates',
  },
}
